<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar :color="toolbarColor" dark>
                <v-btn icon @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>View Applicant - {{ item.firstName }} {{ item.lastName}} </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn text @click="closeDialog()">Close</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-tabs v-model="tab" fixed-tabs :background-color="infoColor" dark show-arrows>
                <v-tab>
                    <v-icon left>mdi-account</v-icon>Applicant
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-home</v-icon>Residence
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-folder-information</v-icon>Office Use
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-account-cog</v-icon>System
                </v-tab>
            </v-tabs>
            <v-container fluid>
                <v-row no-gutters>
                    <v-col cols="12" lg="2">
                        <v-card class="applicant__profile" flat>
                            <v-avatar class="profile" size="200" tile>
                                <v-card class="avatar__card" :loading="avatarLoad">
                                    <v-img v-if="avatar"
                                        lazy-src="../../../assets/admin/applicants/other_avatar-min.png"
                                        :src="getPhotoSrc()">
                                    </v-img>
                                    <v-img v-else-if="item.gender == 'M'"
                                        src="../../../assets/admin/applicants/male_avatar-min.jpg">
                                    </v-img>
                                    <v-img v-else-if="item.gender == 'F'"
                                        src="../../../assets/admin/applicants/female_avatar-min.jpg"></v-img>
                                    <v-img v-else src="../../../assets/admin/applicants/other_avatar-min.png"></v-img>
                                </v-card>
                            </v-avatar>
                            <v-card-title>{{ item.firstName }} {{ item.lastName }}</v-card-title>
                            <v-card-subtitle class="py-0">
                                {{ item.applicantRole == "residenceAssistant" ? "Residence Assistant" : "Student" }}
                            </v-card-subtitle>
                            <v-card-subtitle class="py-0">{{ item.studentnumber }}</v-card-subtitle>
                            <v-card-subtitle class="py-0"><a :href="`mailto:${item.email}`">{{ item.email }}</a>
                            </v-card-subtitle>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="10">
                        <v-tabs-items v-model="tab" class="pb-12">
                            <v-tab-item>
                                <v-card flat>
                                    <!-- Applicant -->
                                    <v-card-title class="pb-0">Applicant Information</v-card-title>
                                    <!-- Profile -->
                                    <profile :item="item"></profile>
                                    <!-- Address -->
                                    <applicant-address :item="item"></applicant-address>
                                    <!-- Contact -->
                                    <contact :item="item"></contact>
                                    <!-- Parent -->
                                    <v-card-title class="pb-0">Parent/Guardian Contact Information</v-card-title>
                                    <!-- Information -->
                                    <parent-information :item="item"></parent-information>
                                    <v-card-title class="pb-0">Signed Version of Rules of Residence</v-card-title>
                                    <!-- Rules of Residence -->
                                    <RulesOfResidence :item="item"></RulesOfResidence>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card v-if="item.applicantRole == 'residenceAssistant'" flat>
                                    <v-card-title class="pb-0">Residence Information</v-card-title>
                                    <!-- Building Preference -->
                                    <ra-building-information :item="item"></ra-building-information>
                                    <!-- General -->
                                    <v-card-title class="pb-0">General Information</v-card-title>
                                    <!-- Information -->
                                    <ra-general-information :item="item"></ra-general-information>
                                    <!-- Accommodation Consideration -->
                                    <accommodation-consideration :item="item"></accommodation-consideration>
                                </v-card>
                                <v-card v-else flat>
                                    <v-card-title class="pb-0">Residence Information</v-card-title>
                                    <!-- Building Preference -->
                                    <building-information :item="item"></building-information>
                                    <!-- Placement -->
                                    <placement-information :item="item"></placement-information>
                                    <!-- Accommodation Consideration -->
                                    <accommodation-consideration :item="item"></accommodation-consideration>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card flat>
                                    <v-card-title class="pb-0">Office Use</v-card-title>
                                    <!-- Office Use -->
                                    <office-use :item="item" :permission="permission"
                                        @getCurrentApplicant="getCurrentApplicant" @refreshData="refreshData"
                                        @setNotification="setNotification">
                                    </office-use>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card-text flat>
                                    <v-card-title class="pb-0">System</v-card-title>
                                    <!-- System -->
                                    <system :item="item" :permission="permission" @closeDialog="closeDialog"
                                        @refreshData="refreshData" @setNotification="setNotification"></system>
                                </v-card-text>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import AccommodationConsideration from './AccommodationConsideration';
import ApplicantAddress from './Address';
import BuildingInformation from './Building';
import Contact from './Contact';
import OfficeUse from './OfficeUse';
import ParentInformation from './Parent';
import PlacementInformation from './Placement';
import RaBuildingInformation from './ResidenceAssistant/Building';
import RaGeneralInformation from './ResidenceAssistant/GeneralInformation';
import Profile from './Profile';
import System from './System';
import RulesOfResidence from './RulesOfResidence.vue';

export default {
    name: 'applicant-information',
    components: {
        AccommodationConsideration,
        ApplicantAddress,
        BuildingInformation,
        Contact,
        OfficeUse,
        ParentInformation,
        PlacementInformation,
        RaBuildingInformation,
        RaGeneralInformation,
        Profile,
        System,
        RulesOfResidence
    },
    props: {
        avatar: {
            required: true
        },
        dialog: {
            required: true,
            type: Boolean
        },
        item: {
            required: true,
            type: Object
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            avatarLoad: true,
            tab: null
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        getCurrentApplicant() {
            this.$emit('getCurrentApplicant');
        },
        getPhotoSrc() {
            if (this.avatar) {
                return `data:image/jpeg;base64,${this.avatar}`
            }

            return '';
        },
        refreshData() {
            this.$emit('refreshData');
        },
        resetTab() {
            this.tab = null;
        },
        setAvatarLoad(bool) {
            this.avatarLoad = bool;
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        toolbarColor() {
            return '#1dc9b7';
        }
    },
    created() {
        if (this.item.applicantRole == "residenceAssistant") {
            this.item.allergiesType ? this.item.allergiesType : [];
        }
    }
}
</script>

<style>
.applicant__profile {
    word-break: normal;
}

.avatar__card {
    padding-top: 5px;
}

.v-card__text {
    padding-bottom: 0 !important;
}

.col-12 {
    padding-top: 0;
}
</style>